// What the widget's card shows below the setting tiles
const aiAssistantCardFooters = {
    NONE: 'NONE',
    CONFIRMATION: 'CONFIRMATION',
    PROGRESS: 'PROGRESS',
};

export default aiAssistantCardFooters;
